import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Button, Loader } from "@components/atoms";
import { ProductTile } from "@components/molecules";
import { generateProductUrl } from "@temp/core/utils";
import * as S from "./styles";
export var ProductList = function ProductList(_ref) {
  var cat = _ref.cat,
      category = _ref.category,
      products = _ref.products,
      _ref$canLoadMore = _ref.canLoadMore,
      canLoadMore = _ref$canLoadMore === void 0 ? false : _ref$canLoadMore,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      testingContextId = _ref.testingContextId,
      _ref$onLoadMore = _ref.onLoadMore,
      onLoadMore = _ref$onLoadMore === void 0 ? function () {
    return null;
  } : _ref$onLoadMore;
  console.log("products", products);
  console.log("category", category);
  console.log("cat", cat);
  return React.createElement(React.Fragment, null, React.createElement(S.List, {
    "data-test": "productList",
    "data-test-id": testingContextId
  }, products.map(function (product) {
    var id = product.id,
        name = product.name;
    return id && name && React.createElement(Link, {
      to: generateProductUrl(id, name),
      key: id
    }, React.createElement(ProductTile, {
      product: product
    }));
  })), React.createElement(S.Loader, null, loading ? React.createElement(Loader, null) : canLoadMore && React.createElement(Button, {
    testingContext: "loadMoreProductsButton",
    color: "secondary",
    onClick: onLoadMore
  }, React.createElement(FormattedMessage, {
    id: "@next.components.organisms.ProductList.ProductList.2783099424",
    defaultMessage: "More +"
  }))));
};